import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { forwardRef } from 'react';

export const EmptyBatteryIcon = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ width = 27, height = 12, color = 'white', ...props }, ref) => {
    return (
      <SvgIcon ref={ref} width={width} height={height} sx={{ color }} viewBox={`0 0 ${width} ${height}`} {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.625 0H21.375C22.8247 0 24 1.34315 24 3V9C24 10.6569 22.8247 12 21.375 12H2.625C1.17525 12 0 10.6569 0 9V3C0 1.34315 1.17525 0 2.625 0ZM2.625 1C1.6585 1 0.875 1.89543 0.875 3V9C0.875 10.1046 1.6585 11 2.625 11H21.375C22.3415 11 23.125 10.1046 23.125 9V3C23.125 1.89543 22.3415 1 21.375 1H2.625Z"
          fill={color}
        />
        <path
          d="M25 4.6C25 4.26863 25.2686 4 25.6 4H26.4C26.7314 4 27 4.26863 27 4.6V7.4C27 7.73137 26.7314 8 26.4 8H25.6C25.2686 8 25 7.73137 25 7.4V4.6Z"
          fill={color}
        />
      </SvgIcon>
    );
  }
);

EmptyBatteryIcon.displayName = "EmptyBatteryIcon";

export const Battery10Icon = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ width = 27, height = 12, color = 'white', ...props }, ref) => {
    return (
      <SvgIcon ref={ref} width={width} height={height} sx={{ color }} viewBox={`0 0 ${width} ${height}`} {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.625 0H21.375C22.8247 0 24 1.34315 24 3V9C24 10.6569 22.8247 12 21.375 12H2.625C1.17525 12 0 10.6569 0 9V3C0 1.34315 1.17525 0 2.625 0ZM2.625 1C1.6585 1 0.875 1.89543 0.875 3V9C0.875 10.1046 1.6585 11 2.625 11H21.375C22.3415 11 23.125 10.1046 23.125 9V3C23.125 1.89543 22.3415 1 21.375 1H2.625Z"
          fill={color}
        />
        <path
          d="M2 3.2C2 2.53726 2.08954 2 2.2 2H3.8C3.91046 2 4 2.53726 4 3.2V8.8C4 9.46274 3.91046 10 3.8 10H2.2C2.08954 10 2 9.46274 2 8.8V3.2Z"
          fill={color}
        />
        <path
          d="M25 4.6C25 4.26863 25.2686 4 25.6 4H26.4C26.7314 4 27 4.26863 27 4.6V7.4C27 7.73137 26.7314 8 26.4 8H25.6C25.2686 8 25 7.73137 25 7.4V4.6Z"
          fill={color}
        />
      </SvgIcon>
    );
  }
);

Battery10Icon.displayName = "Battery10Icon";

export const Battery20Icon = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ width = 27, height = 12, color = 'white', ...props }, ref) => {
    return (
      <SvgIcon ref={ref} width={width} height={height} sx={{ color }} viewBox={`0 0 ${width} ${height}`} {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.625 0H21.375C22.8247 0 24 1.34315 24 3V9C24 10.6569 22.8247 12 21.375 12H2.625C1.17525 12 0 10.6569 0 9V3C0 1.34315 1.17525 0 2.625 0ZM2.625 1C1.6585 1 0.875 1.89543 0.875 3V9C0.875 10.1046 1.6585 11 2.625 11H21.375C22.3415 11 23.125 10.1046 23.125 9V3C23.125 1.89543 22.3415 1 21.375 1H2.625Z"
          fill={color}
        />
        <path
          d="M2 3.2C2 2.53726 2.17909 2 2.4 2H5.6C5.82091 2 6 2.53726 6 3.2V8.8C6 9.46274 5.82091 10 5.6 10H2.4C2.17909 10 2 9.46274 2 8.8V3.2Z"
          fill={color}
        />
        <path
          d="M25 4.6C25 4.26863 25.2686 4 25.6 4H26.4C26.7314 4 27 4.26863 27 4.6V7.4C27 7.73137 26.7314 8 26.4 8H25.6C25.2686 8 25 7.73137 25 7.4V4.6Z"
          fill={color}
        />
      </SvgIcon>
    );
  }
);

Battery20Icon.displayName = "Battery20Icon";

export const Battery30Icon = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ width = 27, height = 12, color = 'white', ...props }, ref) => {
    return (
      <SvgIcon ref={ref} width={width} height={height} sx={{ color }} viewBox={`0 0 ${width} ${height}`} {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.625 0H21.375C22.8247 0 24 1.34315 24 3V9C24 10.6569 22.8247 12 21.375 12H2.625C1.17525 12 0 10.6569 0 9V3C0 1.34315 1.17525 0 2.625 0ZM2.625 1C1.6585 1 0.875 1.89543 0.875 3V9C0.875 10.1046 1.6585 11 2.625 11H21.375C22.3415 11 23.125 10.1046 23.125 9V3C23.125 1.89543 22.3415 1 21.375 1H2.625Z"
          fill={color}
        />
        <path
          d="M2 3.2C2 2.53726 2.26863 2 2.6 2H7.4C7.73137 2 8 2.53726 8 3.2V8.8C8 9.46274 7.73137 10 7.4 10H2.6C2.26863 10 2 9.46274 2 8.8V3.2Z"
          fill={color}
        />
        <path
          d="M25 4.6C25 4.26863 25.2686 4 25.6 4H26.4C26.7314 4 27 4.26863 27 4.6V7.4C27 7.73137 26.7314 8 26.4 8H25.6C25.2686 8 25 7.73137 25 7.4V4.6Z"
          fill={color}
        />
      </SvgIcon>
    );
  }
);

Battery30Icon.displayName = "Battery30Icon";

export const Battery40Icon = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ width = 27, height = 12, color = 'white', ...props }, ref) => {
    return (
      <SvgIcon ref={ref} width={width} height={height} sx={{ color }} viewBox={`0 0 ${width} ${height}`} {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.625 0H21.375C22.8247 0 24 1.34315 24 3V9C24 10.6569 22.8247 12 21.375 12H2.625C1.17525 12 0 10.6569 0 9V3C0 1.34315 1.17525 0 2.625 0ZM2.625 1C1.6585 1 0.875 1.89543 0.875 3V9C0.875 10.1046 1.6585 11 2.625 11H21.375C22.3415 11 23.125 10.1046 23.125 9V3C23.125 1.89543 22.3415 1 21.375 1H2.625Z"
          fill={color}
        />
        <path
          d="M2 3.2C2 2.53726 2.35817 2 2.8 2H9.2C9.64183 2 10 2.53726 10 3.2V8.8C10 9.46274 9.64183 10 9.2 10H2.8C2.35817 10 2 9.46274 2 8.8V3.2Z"
          fill={color}
        />
        <path
          d="M25 4.6C25 4.26863 25.2686 4 25.6 4H26.4C26.7314 4 27 4.26863 27 4.6V7.4C27 7.73137 26.7314 8 26.4 8H25.6C25.2686 8 25 7.73137 25 7.4V4.6Z"
          fill={color}
        />
      </SvgIcon>
    );
  }
);

Battery40Icon.displayName = "Battery40Icon";

export const Battery50Icon = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ width = 27, height = 12, color = 'white', ...props }, ref) => {
    return (
      <SvgIcon ref={ref} width={width} height={height} sx={{ color }} viewBox={`0 0 ${width} ${height}`} {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.625 0H21.375C22.8247 0 24 1.34315 24 3V9C24 10.6569 22.8247 12 21.375 12H2.625C1.17525 12 0 10.6569 0 9V3C0 1.34315 1.17525 0 2.625 0ZM2.625 1C1.6585 1 0.875 1.89543 0.875 3V9C0.875 10.1046 1.6585 11 2.625 11H21.375C22.3415 11 23.125 10.1046 23.125 9V3C23.125 1.89543 22.3415 1 21.375 1H2.625Z"
          fill={color}
        />
        <path
          d="M2 3.2C2 2.53726 2.44772 2 3 2H11C11.5523 2 12 2.53726 12 3.2V8.8C12 9.46274 11.5523 10 11 10H3C2.44771 10 2 9.46274 2 8.8V3.2Z"
          fill={color}
        />
        <path
          d="M25 4.6C25 4.26863 25.2686 4 25.6 4H26.4C26.7314 4 27 4.26863 27 4.6V7.4C27 7.73137 26.7314 8 26.4 8H25.6C25.2686 8 25 7.73137 25 7.4V4.6Z"
          fill={color}
        />
      </SvgIcon>
    );
  }
);

Battery50Icon.displayName = "Battery50Icon";

export const Battery60Icon = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ width = 27, height = 12, color = 'white', ...props }, ref) => {
    return (
      <SvgIcon ref={ref} width={width} height={height} sx={{ color }} viewBox={`0 0 ${width} ${height}`} {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.625 0H21.375C22.8247 0 24 1.34315 24 3V9C24 10.6569 22.8247 12 21.375 12H2.625C1.17525 12 0 10.6569 0 9V3C0 1.34315 1.17525 0 2.625 0ZM2.625 1C1.6585 1 0.875 1.89543 0.875 3V9C0.875 10.1046 1.6585 11 2.625 11H21.375C22.3415 11 23.125 10.1046 23.125 9V3C23.125 1.89543 22.3415 1 21.375 1H2.625Z"
          fill={color}
        />
        <path
          d="M2 3.2C2 2.53726 2.53726 2 3.2 2H12.8C13.4627 2 14 2.53726 14 3.2V8.8C14 9.46274 13.4627 10 12.8 10H3.2C2.53726 10 2 9.46274 2 8.8V3.2Z"
          fill={color}
        />
        <path
          d="M25 4.6C25 4.26863 25.2686 4 25.6 4H26.4C26.7314 4 27 4.26863 27 4.6V7.4C27 7.73137 26.7314 8 26.4 8H25.6C25.2686 8 25 7.73137 25 7.4V4.6Z"
          fill={color}
        />
      </SvgIcon>
    );
  }
);

Battery60Icon.displayName = "Battery60Icon";

export const Battery70Icon = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ width = 27, height = 12, color = 'white', ...props }, ref) => {
    return (
      <SvgIcon ref={ref} width={width} height={height} sx={{ color }} viewBox={`0 0 ${width} ${height}`} {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.625 0H21.375C22.8247 0 24 1.34315 24 3V9C24 10.6569 22.8247 12 21.375 12H2.625C1.17525 12 0 10.6569 0 9V3C0 1.34315 1.17525 0 2.625 0ZM2.625 1C1.6585 1 0.875 1.89543 0.875 3V9C0.875 10.1046 1.6585 11 2.625 11H21.375C22.3415 11 23.125 10.1046 23.125 9V3C23.125 1.89543 22.3415 1 21.375 1H2.625Z"
          fill={color}
        />
        <path
          d="M2 3.2C2 2.53726 2.37608 2 2.84 2H15.16C15.6239 2 16 2.53726 16 3.2V8.8C16 9.46274 15.6239 10 15.16 10H2.84C2.37608 10 2 9.46274 2 8.8V3.2Z"
          fill={color}
        />
        <path
          d="M25 4.6C25 4.26863 25.2686 4 25.6 4H26.4C26.7314 4 27 4.26863 27 4.6V7.4C27 7.73137 26.7314 8 26.4 8H25.6C25.2686 8 25 7.73137 25 7.4V4.6Z"
          fill={color}
        />
      </SvgIcon>
    );
  }
);

Battery70Icon.displayName = "Battery70Icon";

export const Battery80Icon = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ width = 27, height = 12, color = 'white', ...props }, ref) => {
    return (
      <SvgIcon ref={ref} width={width} height={height} sx={{ color }} viewBox={`0 0 ${width} ${height}`} {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.625 0H21.375C22.8247 0 24 1.34315 24 3V9C24 10.6569 22.8247 12 21.375 12H2.625C1.17525 12 0 10.6569 0 9V3C0 1.34315 1.17525 0 2.625 0ZM2.625 1C1.6585 1 0.875 1.89543 0.875 3V9C0.875 10.1046 1.6585 11 2.625 11H21.375C22.3415 11 23.125 10.1046 23.125 9V3C23.125 1.89543 22.3415 1 21.375 1H2.625Z"
          fill={color}
        />
        <path
          d="M2 3.2C2 2.53726 2.42981 2 2.96 2H17.04C17.5702 2 18 2.53726 18 3.2V8.8C18 9.46274 17.5702 10 17.04 10H2.96C2.42981 10 2 9.46274 2 8.8V3.2Z"
          fill={color}
        />
        <path
          d="M25 4.6C25 4.26863 25.2686 4 25.6 4H26.4C26.7314 4 27 4.26863 27 4.6V7.4C27 7.73137 26.7314 8 26.4 8H25.6C25.2686 8 25 7.73137 25 7.4V4.6Z"
          fill={color}
        />
      </SvgIcon>
    );
  }
);

Battery80Icon.displayName = "Battery80Icon";

export const Battery90Icon = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ width = 27, height = 12, color = 'white', ...props }, ref) => {
    return (
      <SvgIcon ref={ref} width={width} height={height} sx={{ color }} viewBox={`0 0 ${width} ${height}`} {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.625 0H21.375C22.8247 0 24 1.34315 24 3V9C24 10.6569 22.8247 12 21.375 12H2.625C1.17525 12 0 10.6569 0 9V3C0 1.34315 1.17525 0 2.625 0ZM2.625 1C1.6585 1 0.875 1.89543 0.875 3V9C0.875 10.1046 1.6585 11 2.625 11H21.375C22.3415 11 23.125 10.1046 23.125 9V3C23.125 1.89543 22.3415 1 21.375 1H2.625Z"
          fill={color}
        />
        <path
          d="M2 3.2C2 2.53726 2.45667 2 3.02 2H17.98C18.5433 2 19 2.53726 19 3.2V8.8C19 9.46274 18.5433 10 17.98 10H3.02C2.45667 10 2 9.46274 2 8.8V3.2Z"
          fill={color}
        />
        <path
          d="M25 4.6C25 4.26863 25.2686 4 25.6 4H26.4C26.7314 4 27 4.26863 27 4.6V7.4C27 7.73137 26.7314 8 26.4 8H25.6C25.2686 8 25 7.73137 25 7.4V4.6Z"
          fill={color}
        />{' '}
      </SvgIcon>
    );
  }
);

Battery90Icon.displayName = "Battery90Icon";

export const Battery100Icon = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ width = 27, height = 12, color = 'white', ...props }, ref) => {
    return (
      <SvgIcon ref={ref} width={width} height={height} sx={{ color }} viewBox={`0 0 ${width} ${height}`} {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.625 0H21.375C22.8247 0 24 1.34315 24 3V9C24 10.6569 22.8247 12 21.375 12H2.625C1.17525 12 0 10.6569 0 9V3C0 1.34315 1.17525 0 2.625 0ZM2.625 1C1.6585 1 0.875 1.89543 0.875 3V9C0.875 10.1046 1.6585 11 2.625 11H21.375C22.3415 11 23.125 10.1046 23.125 9V3C23.125 1.89543 22.3415 1 21.375 1H2.625Z"
          fill={color}
        />
        <path
          d="M2 3.2C2 2.53726 2.5104 2 3.14 2H19.86C20.4896 2 21 2.53726 21 3.2V8.8C21 9.46274 20.4896 10 19.86 10H3.14C2.5104 10 2 9.46274 2 8.8V3.2Z"
          fill={color}
        />
        <path
          d="M25 4.6C25 4.26863 25.2686 4 25.6 4H26.4C26.7314 4 27 4.26863 27 4.6V7.4C27 7.73137 26.7314 8 26.4 8H25.6C25.2686 8 25 7.73137 25 7.4V4.6Z"
          fill={color}
        />
      </SvgIcon>
    );
  }
);

Battery100Icon.displayName = "Battery100Icon";

export const BatteryUnknownIcon = forwardRef<SVGSVGElement, SvgIconProps>(
  ({ width = 27, height = 12, color = 'white', ...props }, ref) => {
    return (
      <SvgIcon ref={ref} width={width} height={height} sx={{ color }} viewBox={`0 0 ${width} ${height}`} {...props}>
        <path
          d="M7.75879 0C7.62876 0.112259 7.50173 0.228803 7.37988 0.351562C7.19362 0.539252 7.05049 0.760595 6.95215 1H2.625C1.6585 1 0.875 1.89543 0.875 3V9C0.875 10.1046 1.6585 11 2.625 11H8.63477C8.69707 11.3531 8.82083 11.6908 9.00684 12H2.625C1.17525 12 0 10.6569 0 9V3C0 1.34315 1.17525 0 2.625 0H4.19189H7.75879Z"
          fill={color}
        />
        <path
          d="M21.375 0C22.8247 0 24 1.34315 24 3V9C24 10.6569 22.8247 12 21.375 12H14.2656C14.4531 11.6939 14.5814 11.3569 14.6455 11H21.375C22.3415 11 23.125 10.1046 23.125 9V3C23.125 1.89543 22.3415 1 21.375 1H16.3672C16.1954 0.641962 15.9712 0.306297 15.6914 0C15.6914 0 19.9253 0 21.375 0Z"
          fill={color}
        />
        <path
          d="M24.9999 4.6C24.9999 4.26863 25.2686 4 25.5999 4H26.3999C26.7313 4 26.9999 4.26863 26.9999 4.6V7.4C26.9999 7.73137 26.7313 8 26.3999 8H25.5999C25.2686 8 24.9999 7.73137 24.9999 7.4V4.6Z"
          fill={color}
        />
        <path
          d="M10.9593 8.17147C10.8767 7.67483 10.9062 7.23631 11.0478 6.85591C11.1894 6.4755 11.3841 6.1268 11.6318 5.8098C11.8914 5.4928 12.151 5.19164 12.4106 4.90634C12.682 4.62104 12.9121 4.33573 13.1009 4.05043C13.2897 3.76513 13.3841 3.45341 13.3841 3.11527C13.3841 2.6926 13.2366 2.33333 12.9416 2.03746C12.6584 1.73103 12.2336 1.57781 11.6672 1.57781C11.2779 1.57781 10.9062 1.66234 10.5522 1.83141C10.21 1.98991 9.90323 2.21182 9.63185 2.49712L8.79999 1.81556C9.17757 1.43516 9.61415 1.12344 10.1097 0.880403C10.6171 0.626801 11.1953 0.5 11.8442 0.5C12.741 0.5 13.4549 0.727185 13.9858 1.18156C14.5286 1.63593 14.8 2.25408 14.8 3.03602C14.8 3.44813 14.7056 3.82325 14.5168 4.16138C14.328 4.48895 14.092 4.80067 13.8088 5.09654C13.5375 5.39241 13.272 5.69356 13.0124 6C12.7528 6.30644 12.5404 6.63401 12.3752 6.98271C12.2218 7.33141 12.1746 7.72767 12.2336 8.17147H10.9593ZM11.6318 11.5C11.3369 11.5 11.0891 11.4102 10.8885 11.2305C10.6879 11.0403 10.5876 10.8026 10.5876 10.5173C10.5876 10.2109 10.6879 9.96782 10.8885 9.78819C11.0891 9.59798 11.3369 9.50288 11.6318 9.50288C11.9268 9.50288 12.1746 9.59798 12.3752 9.78819C12.5876 9.96782 12.6938 10.2109 12.6938 10.5173C12.6938 10.8026 12.5876 11.0403 12.3752 11.2305C12.1746 11.4102 11.9268 11.5 11.6318 11.5Z"
          fill={color}
        />
      </SvgIcon>
    );
  }
);

BatteryUnknownIcon.displayName = "BatteryUnknownIcon";

// Create a mapping from variant strings to components
export const batteryIconMapping = {
  '0': EmptyBatteryIcon,
  '10': Battery10Icon,
  '20': Battery20Icon,
  '30': Battery30Icon,
  '40': Battery40Icon,
  '50': Battery50Icon,
  '60': Battery60Icon,
  '70': Battery70Icon,
  '80': Battery80Icon,
  '90': Battery90Icon,
  '100': Battery100Icon,
  unknown: BatteryUnknownIcon,
};

export const BatteryChargeIcon = forwardRef<SVGSVGElement, SvgIconProps & { variant, strokeColor }>(
  ({ variant, strokeColor, width, height, ...props }, ref) => {
    const IconComponent = batteryIconMapping[variant];

    if (!IconComponent) {
      // Handle the case where the variant is not found
      console.warn(`Unknown battery variant: ${variant}`);
      return null;
    }

    return <IconComponent ref={ref} height={height} width={width} {...props} color={strokeColor} />;
  }
);

BatteryChargeIcon.displayName = "BatteryChargeIcon";